var _rect, _rect2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconProfileCoin = function SvgIconProfileCoin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.667,
    y: 0.667,
    width: 14.667,
    height: 14.667,
    rx: 7.333,
    fill: "#E59722"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.667,
    y: 2.667,
    width: 10.667,
    height: 10.667,
    rx: 5.333,
    fill: "#FFCF23"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 3.333a4.667 4.667 0 0 0-3.13 8.129 4.667 4.667 0 0 1 6.591-6.591 4.655 4.655 0 0 0-3.461-1.538Z",
    fill: "#FFDD65"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.333a2 2 0 1 0 0 4s0 1-1.333 2c0 0 3.333-.667 3.333-4a2 2 0 0 0-2-2Z",
    fill: "#E59722"
  })));
};
export default SvgIconProfileCoin;